module.exports = __webpack_public_path__ + "static/fingcrossed_emoji-b9a5aa74f1f6188629a9f235362cbbb3.svg";